import Button from '@/components/Button.jsx';
import { HiMiniEllipsisHorizontal } from '@/components/react-icons/main';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import IconV2 from '@/components/v2/IconV2.jsx';
import { randomId } from '@shared/utils/randomId.js';

// A Page.Table row on a phone (the table's mobileCard prop), drawn like the workflow and job list cards: content on
// top, then a strip with footer text or the actions named in `card.buttons`. Other actions stay in the menu.
const TableMobileCard = ({ data, card, actions = [], actionMenuFitContent = false, onAction, onRowClick }) => {
  const id = randomId();
  const buttonValues = card.buttons || [];
  const buttons = actions.filter((action) => buttonValues.includes(action.value));
  const menu = actions.filter((action) => !buttonValues.includes(action.value));
  const details = (card.details || []).filter(Boolean);

  return (
    <div className={`table-mobile-card ${onRowClick ? 'clickable' : ''}`} onClick={(event) => onRowClick?.(data, event)}>
      <div className={'card-main'}>
        <div className={'card-title-row'}>
          <span className={'card-title'}>{card.title}</span>
          {card.badge}
          {menu.length > 0 && (
            <div className={'card-menu'}>
              <IconV2 icon={HiMiniEllipsisHorizontal} className={`light-medium actions-button ${id}`} />
              <FloatingSelectV2 className={actionMenuFitContent ? 'fit-content' : ''} triggers={[`.${id}`]} options={menu} onChange={(action) => onAction?.(data, action)} useSearch={false} smartWidth={actionMenuFitContent} virtualize={actionMenuFitContent ? false : undefined} />
            </div>
          )}
        </div>
        {card.subtitle && <div className={'card-subtitle'}>{card.subtitle}</div>}
        {details.map((detail, index) => (
          <div key={index} className={`card-detail ${detail.muted ? 'muted' : ''}`}>
            {detail.icon && <IconV2 icon={detail.icon} size={12} className={'light-medium'} />}
            <span>{detail.value}</span>
          </div>
        ))}
      </div>
      {(buttons.length > 0 || card.footer) && (
        <div className={'card-footer'}>
          {buttons.length > 0
            ? buttons.map((action) => (
                <Button key={action.value} size={'sm'} icon={action.icon} loading={action.loading} disabled={buttons.some((button) => button.loading)} onClick={() => onAction?.(data, action)}>
                  {action.label}
                </Button>
              ))
            : card.footer}
        </div>
      )}
    </div>
  );
};

export default TableMobileCard;
